// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"ChatSupport_iconContainer__GSjkn","badge":"ChatSupport_badge__GGKYq","dismissButton":"ChatSupport_dismissButton__TjhGI"};